import React, { FC, ReactNode } from "react";
import { FallbackProps } from "react-error-boundary";
import styles from "./ErrorBoundary.module.scss";

type Props = FallbackProps & {
  /** The way out of the broken page; a plain link to `/` by default. */
  renderHome?: (className: string) => ReactNode;
  /** Label for the retry button. */
  retryLabel?: string;
};

// Raw error text helps while developing but means nothing to users.
const showDetails = process.env.NODE_ENV !== "production";

const ErrorFallback: FC<Props> = ({
  error,
  resetErrorBoundary,
  renderHome = (className) => (
    <a className={className} href="/">
      Go to dashboard
    </a>
  ),
  retryLabel = "Retry",
}) => (
  <div role="alert" className={styles.fallback}>
    <h2 className={styles.title}>Something went wrong</h2>
    <p className={styles.text}>
      This page could not be shown. Try again, or go back to the dashboard.
    </p>
    {showDetails && (
      <pre className={styles.details}>{error?.message ?? String(error)}</pre>
    )}
    <div className={styles.actions}>
      <button
        type="button"
        className={styles.primary}
        onClick={resetErrorBoundary}
      >
        {retryLabel}
      </button>
      {renderHome(styles.secondary)}
    </div>
  </div>
);

export default ErrorFallback;
